module.exports = "<div #dataR></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/terms/terms.component.html
// module id = ./src/app/terms/terms.component.html
// module chunks = main